import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { alleFenster } from "../components/windowManager/browserFenster/fensterRegister";

interface CommandPaletteValue {
  open: boolean;
  setOpen: (v: boolean) => void;
  toggle: () => void;
}

const Ctx = createContext<CommandPaletteValue | undefined>(undefined);

export const useCommandPalette = (): CommandPaletteValue => {
  const c = useContext(Ctx);
  if (!c) throw new Error("useCommandPalette must be used within CommandPaletteProvider");
  return c;
};

/**
 * Hält den Offen-Zustand der globalen Such-/Command-Palette und registriert den
 * globalen ⌘K / Strg+K-Shortcut (Toggle). Esc-Schließen + Query liegen in der
 * Palette-Komponente selbst.
 */
export const CommandPaletteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        setOpen((v) => !v);
      }
    };
    alleFenster.addEventListener("keydown", onKey);
    return () => alleFenster.removeEventListener("keydown", onKey);
  }, []);

  const value = useMemo<CommandPaletteValue>(
    () => ({ open, setOpen, toggle: () => setOpen((v) => !v) }),
    [open],
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};
